'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var SET_VERIFIED_ACCOUNT = 'SET_VERIFIED_ACCOUNT';

function _AccountReducers() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [];

  this.init = function () {};

  this.initAllReady = function () {};

  this.initialAccountState = {
    account_ready: false
  };

  this.accountReducer = function (state, action) {
    if (typeof state === 'undefined') {
      return this.initialAccountState;
    }
    switch (action.type) {
      case SET_VERIFIED_ACCOUNT:
        return _extends({}, state, { account_ready: action.payload.account_ready });
      default:
        return state;
    }
  }.bind(this);
}